import ReferenceCreate from './ReferenceCreate';
import ReferenceEdit from './ReferenceEdit';

const References: object = {
  create: ReferenceCreate,
  edit: ReferenceEdit,
};

export default References;
